/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';

import * as styled from './TemplateSlug.styled';

export const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <styled.Description>{children}</styled.Description>
    ),
    [BLOCKS.HEADING_3]: (node, children) => (
      <styled.Title>{children}</styled.Title>
    ),
    [BLOCKS.UL_LIST]: (node, children) => <styled.List>{children}</styled.List>,
    [BLOCKS.LIST_ITEM]: (node, children) => (
      <styled.ListItem>{children}</styled.ListItem>
    ),
  },
};
